import React from "react";
import Back from "../../../../components/shared/back";
import Button from "../../../../components/shared/custom-btn";
import VehicleDetails from "../vehicle-details";
import Loader from "../../../../components/shared/loader";

const VehicleViewHeader = ({
    vehicleError,
    mediaError,
    loading,
    vehicle,
    vehicleId,
    accountId,
    setVehicle,
    activeTab,
    mediaLoading,
    handleOpenAddModal
}) => {

    return (
        <>
            <Back />
            <div className="bg-white flex flex-col md:flex-row items-start md:items-center w-full justify-between gap-6 mt-4">
                {vehicleError && (
                    <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md">{vehicleError}</div>
                )}
                {mediaError && (
                    <div className="text-red-600 bg-red-100 px-4 py-2 rounded-md">{mediaError}</div>
                )}
                {loading ? (
                    <div className="w-full flex justify-center">
                        <Loader />
                    </div>
                ) : (
                    <VehicleDetails
                        vehicle={vehicle}
                        vehicleId={vehicleId}
                        accountId={accountId}
                        setVehicle={setVehicle}
                    />
                )}
                {!(activeTab === "Overview" || activeTab === "Reminders") && (
                    <Button
                        label={activeTab === "Tires" ? `Assign Tire` : `Add ${activeTab === 'ServiceConfig' ? 'Configuration' : activeTab}`}
                        className={`${activeTab === 'Tires' && 'hidden'} text-white px-4 !py-1 rounded-lg bg-btnBg`}
                        onClick={handleOpenAddModal}
                        loading={mediaLoading}
                        disabled={mediaLoading}
                        loadingLabel={mediaLoading ? 'Uploading...' : ''}
                    />
                )}
            </div>
        </>
    );
};

export default VehicleViewHeader; 